module.exports = __webpack_public_path__ + "img/Belize.68b3b6fe.png";